import React from 'react';
import { useLocation, Routes, Route, Navigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import SubHeader from 'components/SubHeader';
import FooterBar from 'components/FooterBar';
import SettingsNav from './components/SettingsNav';
import RatePlan from './components/RatePlan';
import CouponCode from './components/CouponCode';
import HotelInfoAndPolicies from './components/HotelInfoAndPolicies';
import { Content, Container, NavContainer } from './styles';

const Settings = () => {

  const { pathname } = useLocation()

  return (
    <>
      <Helmet>
        <title>Settings - Rook Hotel PMS</title>
        <meta name="description" content="Settings - Rook Hotel PMS" />
      </Helmet>
      <SubHeader>
        <div className='title'>
          <Link
            className='highlight'
            to='/settings'
          >
            Settings
          </Link> 
          {(pathname.split('/')[2])? (' > ' + pathname.split('/')[2]): ''}
        </div>
      </SubHeader>
      <Content>
        <NavContainer>
          <SettingsNav />
        </NavContainer>
        <Container>
          <Routes>
            <Route
              path={'/'}
              element={<>Settings Dashboard</>}
            />
            <Route
              path={'rate-plan'}
              element={<RatePlan />}
            />
            <Route
              path={'coupon-code'}
              element={<CouponCode />}
            />
            <Route
              path={'room-type-configuration'}
              element={<RatePlan />}
            />
            <Route
              path={'room-configuration'}
              element={<RatePlan />}
            />
            <Route
              path={'hotel-charges'}
              element={<RatePlan />}
            />
            <Route
              path={'hotel-info-and-policies'}
              element={<HotelInfoAndPolicies />}
            />
            <Route path="*" element={<Navigate to="/settings" replace />} />
          </Routes>
        </Container>
      </Content>
      <FooterBar />
    </>
  );
};

export default Settings;